export type Callback<T> = (payload: T) => void;

export enum Types {
  DELETE,
  EDIT,
}
